import activityShortRoutes from '@/router/router-child/activity-short'

/** path 段（不含前导 /）-> 完整简洁路由 path */
const shortPathMap = new Map()
activityShortRoutes.forEach(route => {
  const key = route.path.replace(/^\//, '')
  if (key && !shortPathMap.has(key)) {
    shortPathMap.set(key, route.path)
  }
})

/** nameEn 规范化：trim，空格替换为 - */
export function normalizeActivityNameEn (nameEn) {
  if (nameEn == null) return ''
  return String(nameEn).trim().replace(/\s+/g, '-')
}

/** 命中简洁路由时返回 path（如 /CNCC），否则 null */
export function getActivityShortPath (nameEn) {
  const key = normalizeActivityNameEn(nameEn)
  if (!key) return null
  return shortPathMap.get(key) || null
}

/** 新窗口打开活动详情（简洁路由优先） */
export function openActivityDetailInNewTab (nameEn, { contestId, seasonId } = {}) {
  const shortPath = getActivityShortPath(nameEn)
  const base = window.location.href.split('/#/')[0] + '/#'
  if (shortPath) {
    window.open(base + shortPath)
    return
  }
  window.open(base + `/GameData/${nameEn}?contestId=${contestId}&seasonId=${seasonId}`)
}

/** 当前页跳转活动详情 route 配置（简洁路由优先） */
export function getActivityDetailRoute (nameEn, { contestId, seasonId } = {}) {
  const shortPath = getActivityShortPath(nameEn)
  if (shortPath) {
    return { path: shortPath }
  }
  return {
    path: `/GameData/${nameEn}`,
    query: {
      contestId,
      seasonId
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/activityShortRoute.js